import { Feature } from "ol";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style";
import { LineString, MultiPoint } from "ol/geom";
import { DrawType } from "./enums";

const white = [255, 255, 255, 1];
const blue = [0, 153, 255, 1];
const blueFill = [0, 153, 255, 0.3];
const orange = [250, 140, 35, 1];
const orangeFill = [250, 140, 35, 0.15];
const red = [255, 0, 0, 1];
const primaryDark = "#4c4c4c";
const yellow = [255, 255, 0, 0.8];
const brightYellow = [255, 255, 0, 0.9];
const yellowFill = [255, 255, 0, 0.15];
const LVMRoadColor = [168, 112, 0, 255];

const vertice = new CircleStyle({
    radius: 6,
    fill: new Fill({
        color: blue
    }),
    stroke: new Stroke({
        color: white,
        width: 1.5
    })
});

const strokeStyle = new Stroke({
    color: red,
    width: 4
});

const selectStrokeStyle = new Stroke({
    color: blue,
    width: 3
});

const highLightStrokeStyle = new Stroke({
    color: yellow,
    width: 3
});

export const getDrawingSymbol = (
    type: DrawType,
    roadName: string,
    isSelect?: boolean,
    isModify?: boolean
): Style | Style[] => {
    const isNaturalRoad = roadName === "Dabiska brauktuve";
    if (type === DrawType.PolygonProperty) {
        return isSelect
            ? new Style({
                  fill: new Fill({
                      color: blueFill
                  }),
                  stroke: selectStrokeStyle
              })
            : new Style({
                  fill: new Fill({
                      color: orangeFill
                  }),
                  stroke: strokeStyle
              });
    } else if (type === DrawType.PolylineLvmRoad) {
        return isSelect
            ? new Style({
                  stroke: new Stroke({ color: blue, width: 4, lineDash: isNaturalRoad && [4, 4] })
              })
            : new Style({
                  stroke: new Stroke({ color: red, width: 4, lineDash: isNaturalRoad && [4, 4] })
              });
    } else if (type === DrawType.PolylineRoad) {
        if (isModify) {
            return new Style({
                image: vertice
            });
        }
        if (isSelect) {
            return [
                new Style({
                    stroke: selectStrokeStyle
                }),
                new Style({
                    image: vertice,
                    geometry: (feature) =>
                        new MultiPoint(((feature as Feature).getGeometry() as LineString).getCoordinates())
                })
            ];
        }
        return new Style({
            stroke: strokeStyle
        });
    } else {
        return new Style({
            // image: new CircleStyle({
            //     fill: new Fill({
            //         color: white
            //     }),
            //     stroke: new Stroke({
            //         color: isModify ? blue : isSelect ? blue : orange,
            //         width: isModify ? 2 : 3
            //     }),
            //     radius: 9
            // })
            text: new Text({
                font: 'normal normal 400 18px "icomoon"',
                fill: new Fill({
                    color: white
                }),
                text: String.fromCodePoint(0xe91a),
                stroke: new Stroke({
                    color: isModify ? blue : isSelect ? blue : red,
                    width: isModify ? 3 : 4
                })
            })
        });
    }
};

export const getHighLightSymbol = (feature: Feature): Style => {
    const type = feature.getGeometry().getType();
    const isNaturalRoad = feature.get("ROADSUBTYPE") === 1;

    if (type === "Polygon") {
        return new Style({
            fill: new Fill({
                color: yellowFill
            }),
            stroke: highLightStrokeStyle
        });
    } else if (type === "LineString") {
        return new Style({
            stroke: new Stroke({
                color: yellow,
                width: 5,
                lineDash: isNaturalRoad && [4, 4]
            })
        });
    } else if (type === "Point") {
        return new Style({
            image: new CircleStyle({
                fill: new Fill({
                    color: white
                }),
                stroke: new Stroke({
                    color: yellow,
                    width: 2
                }),
                radius: 12
            })
        });
    }
};

export const LVMRoadStyle = (feature: Feature): Style => {
    const isClicked = feature.get("CLICKED") || feature.get("HOVERED");
    const isNaturalRoad = feature.get("ROADSUBTYPE") === 1;
    return new Style({
        stroke: new Stroke({
            color: isClicked ? brightYellow : LVMRoadColor,
            width: isClicked ? 5 : isNaturalRoad ? 2 : 3,
            lineDash: isNaturalRoad && [4, 4]
        }),
        text: new Text({
            font: isClicked ? "bold 15px sans-serif" : "bold 14px sans-serif",
            placement: "line",
            fill: new Fill({
                color: LVMRoadColor
            }),
            stroke: new Stroke({
                color: isClicked ? yellow : white,
                width: 2
            }),
            text: feature.get("ROADNAME")
        })
    });
};
